export default [
    {
        path: '/waters',
        name: 'waters',
        component: () => import('@/views/pages/water/List.vue'),
        meta: {
            pageTitle: 'breadcrumb.waters',
            resource: 'water',
            action: 'list',
            breadcrumb: [
                {
                    text: 'breadcrumb.list',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/waters/horinfo-sync',
        name: 'horinfo-sync',
        component: () => import('@/views/pages/water/Sync.vue'),
        meta: {
            pageTitle: 'breadcrumb.waters',
            resource: 'water',
            action: 'list',
            breadcrumb: [
                {
                    text: 'breadcrumb.sync',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/waters/:id',
        name: 'show-water',
        component: () => import('@/views/pages/water/Show.vue'),
        meta: {
            pageTitle: 'breadcrumb.waters',
            resource: 'water',
            action: 'list',
            breadcrumb: [
                {
                    text: 'breadcrumb.show',
                    active: true,
                },
            ],
        },
    },
]
